'use client';
import { cloneElement } from 'react';
import { useFocusTrap, useMergedRefs } from '@s7/hooks';
import { isElement } from '@s7/react-utils';
import { IDENT, defaultProps } from './FocusTrap.contract.js';

var FocusTrap = function(props) {
    var children = props.children, _props_active = props.active, active = _props_active === void 0 ? defaultProps.active : _props_active, _props_refProp = props.refProp, refProp = _props_refProp === void 0 ? defaultProps.refProp : _props_refProp;
    var focusTrapRef = useFocusTrap(active);
    var ref = useMergedRefs(focusTrapRef, children == null ? void 0 : children.ref);
    if (!isElement(children)) {
        return children;
    }
    var _obj;
    return /*#__PURE__*/ cloneElement(children, (_obj = {}, _obj[refProp] = ref, _obj));
};
var FocusTrap$1 = FocusTrap;
FocusTrap.displayName = IDENT;

export { FocusTrap, FocusTrap$1 as default };
